<template>
	<div class="flex w-full justify-center transition-all duration-500 ease-in-out">
		<div class="w-full xl:max-w-8xl grid grid-cols-2 md:grid-cols-6 gap-2 mx-4 my-4">
			<a
				v-for="(tile, i) in tiles"
				:key="i"
				:href="tile.link"
				class="relative overflow-hidden rounded-lg block"
				:class="{ 'col-span-2': !i, 'md:col-span-3': [0, 1].includes(i), 'md:col-span-2': ![0, 1].includes(i) }"
			>
				<img :src="tile.image" :alt="tile.title" class="rounded-lg w-full h-full min-h-52 max-h-52 md:min-h-96 md:max-h-fit object-center object-cover" />
				<div class="absolute inset-0 flex items-end justify-center bg-gradient-to-tr from-ihh-black/70 to-ihh-secondary-white/10">
					<div class="before-hover w-full">
						<div class="absolute inset-0 flex flex-col items-start justify-end text-white bottom-4 left-4 md:bottom-10 md:left-10 pr-4">
							<div class="text-2xl md:text-4xl tracking-wide font-semibold max-w-40 md:max-w-none">{{ tile.title }}</div>
							<div class="text-xs md:text-base">{{ tile.description }}</div>
							<div class="md:mt-4 rounded-xl">
								<div class="cursor-pointer group border-3 border-ihh-secondary-white rounded-xl overflow-hidden">
									<span class="block text-xs md:text-sm group-hover:bg-ihh-secondary-white px-4 py-2 md:px-8 md:py-3 transition ease-in-out">Shop now</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
import { DEFAULT_HERO_TILES } from '../../../../../config/helpers/homePage/sections.js'

// The five category tiles under the intro video. Their images, titles and
// links are set on Storefront › Home page in the admin.
export default {
	props: {
		tiles: { type: Array, default: () => DEFAULT_HERO_TILES },
	},
}
</script>
